/**
 * The web app that belongs to the API this build talks to: `api.<domain>` → `https://<domain>`,
 * `api-test.<domain>` → `https://test.<domain>`. A link must open the environment the data lives in:
 * a v2 build for totodo.io handed out `https://totodo.app/...` links (v1, another database).
 */
export function webOriginForApi(apiBase: string): string | undefined {
  try {
    const host = new URL(apiBase).hostname
    if (host.startsWith("api-test.")) return `https://test.${host.slice("api-test.".length)}`
    if (host.startsWith("api.")) return `https://${host.slice("api.".length)}`
  } catch {
    // relative or invalid base: no web origin to derive
  }
  return undefined
}
